const appointments = {
  firestorePath: '/appointments',
  firestoreRefType: 'collection',
  moduleName: 'appointments',
  statePropName: 'appointments',
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: '%convertTimestamp%', // default
      updated_at: '%convertTimestamp%', // default
      startDate: '%convertTimestamp%'
    },
  },
  state: {},
  getters: {
    getAppointments: state => {
      return _.orderBy(state.appointments, ['startDate', 'startTime', 'endTime'], ['desc']);
    },
    getCandidateAppointments: (state, getters) => (id) => {
      let candidateAppointments =  _.filter(getters.getAppointments, ['candidateId', id]);
      return _.orderBy(candidateAppointments, ['startDate', 'startTime', 'endTime'], ['desc']);
    }
  },
  mutations: {},
  actions: {
    setAppointments: payload => {
      payload.commit('setAppointments')
    },
  },
}

export default appointments